import React from 'react'
import Radium from 'radium'
import Link from 'gatsby-link'
import { HaikuSVG, FacebookSVG, TwitterSVG, SlackSVG, YouTubeSVG,} from './assets/icons'
import { colors, colorsMapped, spacing, sizing } from './assets/shibui';

const S = {
  section: {
    maxWidth: sizing.xxxl,
    margin: sizing.xs + 'px auto 0',
    position: 'relative',
    zIndex: 10,
    '@media screen and (max-width: 1200px)': {
      padding: '0 ' + spacing.md + 'px'
    }
  },
  finalStrip: {
    padding: '13px 0',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: spacing.xl + 'px auto ' + spacing.xs + 'px',
    borderTop: '1px solid ' + colorsMapped.borderColor.color
  },
  aboutText: {
    textAlign: 'left',
    marginTop: -2,
    fontSize: 12
  },
  floatLeft: {
    float: 'left'
  },
  floatRight: {
    float: 'right'
  },
  noticeHolster: {position: 'relative'},
  notice: {
    backgroundColor: colors.fuss50.color,
    width: 13,
    height: 13,
    borderRadius: '50%',
    position: 'absolute',
    left: 42,
    top: 6
  },
  linksSection: {
    margin: '0 auto',
    display: 'flex',
    padding: '40px 0 58px',
    '@media screen and (maxWidth: 860px)': {
      display: 'none'
    }
  },
  column: {
    flexGrow: 1
  },
  title: {
    fontSize: '1.28rem',
    fontWeight: '400',
    textTransform: 'uppercase',
    color: colors.graphite.color,
    marginBottom: spacing.sm + spacing.md,
    letterSpacing: 1.3,
  },
  footLink: {
    marginBottom: spacing.md,
    color: colors.midnight.color
  },
  logo: {
    width: 40,
    marginTop: 3
  }
}

class Footer extends React.Component {
  constructor() {
    super()

    this.setIconHover = this.setIconHover.bind(this)

    this.state = {
      twitterHovered: false,
      facebookHovered: false,
      slackHovered: false,
    }
  }

  setIconHover(hovered, target) {
    const hoverKey = `${target}Hovered`
    this.setState({ [hoverKey]: hovered })
  }

  render() {
    return (
      <div id="footer" style={S.section}>
        <div style={S.linksSection}>
          <div style={S.column}>
            <h4 style={[S.title, { color: colors.cyan50.color}]}>Company</h4>
            <div><Link style={S.footLink} className="cyan stash" to={{ pathname: "/blog"}}>Blog</Link></div>
            <div><a style={S.footLink} className="cyan stash" href="mailto:contact@haikuforteams.com?subject=Hello!">Contact</a></div>
            <div>
              <a
                href="https://www.haikuforteams.com/terms-of-service.html"
                style={S.footLink} className="cyan stash"
                rel="noopener noreferrer"
              target="_blank">
                Terms of Service
                </a>
            </div>
            <div>
              <a
                href="https://www.haikuforteams.com/privacy-policy.html"
                style={S.footLink} className="cyan stash"
                rel="noopener noreferrer"
                target="_blank">
                Privacy Policy
              </a>
            </div>
          </div>
          <div style={S.column}>
            <h4 style={[S.title, { color: colors.fuss50.color }]}>Open Source</h4>
            <div><a href="https://diez.org" target='_blank' style={S.footLink} className="stash">Diez</a></div>
            <div><a href="https://github.com/HaikuTeam/" target='_blank' style={S.footLink} className="stash">More on GitHub</a></div>
          </div>
          <div style={S.column}>
            <h4 style={[S.title, { color: colors.tiger50.color }]}>Education</h4>
            <div><Link style={S.footLink} className="tiger stash" to={{ pathname: "/learn/" }}>Learn</Link></div>
            <div><a href="https://share.haiku.ai" style={S.footLink} className="tiger stash">Showcase</a></div>
            <div><a style={S.footLink} className="tiger stash" target="_blank" rel="noopener" href='https://docs.haiku.ai'>Docs</a></div>
            <div><a style={S.footLink} className="tiger stash" target="_blank" rel="noopener" href='https://help.haiku.ai/fundamentals'>Fundamentals</a></div>
          </div>
          <div style={S.column}>
            <h4 style={[S.title, { color: colors.marigold50.color }]}>Support</h4>
            <div><a style={S.footLink} className="marigold stash" target="_blank" rel="noopener" href='https://haikuforteams.com/slack-community'>Community Slack</a></div>
            <div><a style={S.footLink} className="marigold stash" target="_blank" rel="noopener" href='https://help.haiku.ai/my-account'>Account Help</a></div>
            <div><a style={S.footLink} className="marigold stash" target="_blank" rel="noopener" href='https://docs.haiku.ai/release-notes/'>Release Notes</a></div>
            <div><a style={S.footLink} className="marigold stash" target="_blank" rel="noopener" href='https://help.haikuforteams.com/'>Help Articles</a></div>
            <div><a style={S.footLink} className="marigold stash" href="mailto:contact@haikuforteams.com?subject=Feedback!">Give Feedback</a></div>
          </div>
        </div>
        <div style={S.finalStrip}>
          <div style={{transform: 'translateY(5px)'}}>

            <div style={[S.floatLeft, S.aboutText]}>
              <div style={S.logo}>
                <a href='/#top'><HaikuSVG size={31} color={colors.graphite.color} /></a>
              </div>
            </div>
            <div style={[S.floatLeft, S.aboutText]}>
              <div>© Haiku</div>
              <div>San Francisco, CA</div>
            </div>
          </div>
          <div style={{float: 'right'}}>
            <a href='/slack-community/'
              style={[S.floatRight, { marginLeft: spacing.lg, marginTop: 4}]}
              onMouseOver={() => this.setIconHover(true, 'slack')}
              onMouseOut={() => this.setIconHover(false, 'slack')}>
              <SlackSVG color={this.state.slackHovered ? 'url(#linearGradient-1)' : colors.graphite.color} />
            </a>
            <a href='https://www.youtube.com/channel/UCFNlUrip_yGA8Ljk7QcwYog'
              target='_blank'
              style={[S.floatRight, {marginLeft: spacing.lg, marginTop: 2}]}
              onMouseOver={() => this.setIconHover(true, 'youtube')}
              onMouseOut={() => this.setIconHover(false, 'youtube')}>
              <YouTubeSVG color={this.state.youtubeHovered ? 'url(#linearGradient-1)' : colors.graphite.color} />
            </a>
            <a href='https://facebook.com/haikuforteams' target='_blank'
              style={[S.floatRight, {marginLeft: spacing.lg, marginTop: 4}]}
              onMouseOver={() => this.setIconHover(true, 'facebook')}
              onMouseOut={() => this.setIconHover(false, 'facebook')}>
              <FacebookSVG color={this.state.facebookHovered ? 'url(#linearGradient-1)' : colors.graphite.color} />
            </a>
            <a href='https://twitter.com/haikuforteams' target='_blank'
              style={[S.floatRight, {marginLeft: spacing.lg, marginTop: 2,}]}
              onMouseOver={() => this.setIconHover(true, 'twitter')}
              onMouseOut={() => this.setIconHover(false, 'twitter')}>
              <TwitterSVG color={this.state.twitterHovered ? 'url(#linearGradient-1)' : colors.graphite.color} />
            </a>
          </div>
        </div>
          <svg style={{width:0,height:0,position:'absolute'}} focusable="false">
            <linearGradient x1="11.4598703%" y1="24.0749762%" x2="81.5438343%" y2="75.1945656%" id="linearGradient-1">
              <stop stopColor={colors.fuss50.color} offset="0%"></stop>
              <stop stopColor={colors.tiger50.color} offset="100%"></stop>
            </linearGradient>
          </svg>
      </div>
    )
  }
}

export default Radium(Footer)



// WEBPACK FOOTER //
// ./src/components/footer.js